import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { MenuItem, Select, TableSortLabel, SvgIcon } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import IconButton from "@mui/material/IconButton";
import {
  Button,
  Grid,
  Menu,
  InputLabel,
  TextField,
  ListItemIcon,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { useHistory, useRouteMatch, useLocation, Link } from "react-router-dom";
import {
  getDate,
  prospectDetailsPath,
  viewMitsChildReportsPath,
  searchFilter,
  handleSort,
  viewMitsReportsPath,
  getDateTime,
} from "../utils/varialbles";
import http from "../services/reportsPath";
import SearchBar from "material-ui-search-bar";
// import Filter from '../components/filerComponent';
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
// import useFilter from "../components/filterComponent";
// import useFilter from "../components/multifilterComponent";
import useFilter from "../components/sideFilter";
import { textAlign } from "@mui/system";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditSharpIcon from "@material-ui/icons/EditSharp";

import FormControl from "@material-ui/core/FormControl";
import DehazeIcon from "@material-ui/icons/Dehaze";
import MenuIcon from "@material-ui/icons/Menu";
import { PanoramaSharp } from "@material-ui/icons";
import { usePersistentState } from "react-persistent-state";

// import { browserHistory } from 'react-router'
import { browserHistory } from "react-router-dom";
import { createHashHistory } from "history";

const anchorEl = 1;
const setAnchorEl = 2;

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport csvOptions={{ allColumns: true }} />
    </GridToolbarContainer>
  );
}

export default function ViewNestedChildMitReports() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [paramObject, setParamObject] = useState({});
  const [orignalRows, setOriginalRows] = useState([]);
  // (orignalRows);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  // const [anchorEl, setAnchorEl] = React.useState(false);
  const location = useLocation();
  // (location, "location");
  const myparam = location.state;
  const backid = location.id;

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const chistory = createHashHistory();
  // const isMenuOpen = Boolean(anchorEl);
  const form = {
    status: [],
    get_back_date: "",
    assigned_executive__empfname: "",
    cust__createddt: "",
    cust__createddt__condition: "lte",
    get_back_date__condition: "lte",
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [formObject, setFormObject] = React.useState(form);
  let history = useHistory();
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };

  // const [custTask, setCustTask] = useState([]);
  // (custTask);

  // const renderList = (props) =>{
  //   let {value} = props;
  // }

  const [columns, setColumns] = useState([
    {
      headerName: "Date of dvice",
      id: "advice_date",
      show: true,
      format: "Date",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Security Name",
      id: "name",
      show: true,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Action",
      id: "action",
      show: true,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "No of Securities",
      id: "qty",
      show: true,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Secuiry Advice Price",
      id: "price",
      show: true,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Sector",
      id: "sector",
      show: true,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Advised Amount",
      id: "adviceval",
      show: true,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Current Value",
      id: "currentval",
      show: true,
      minWidth: 260,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "CAGR Return",
      id: "cagr",
      show: true,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Return",
      id: "gainper",
      show: true,
      minWidth: 300,
      headerAlign: "center",
      align: "center",
    },
  ]);

  // (columns);

  let staticCols = [
    "Alpha",
    "Advisedval",
    "Currentval",
    "Gainper",
    "Investedval",
  ];
  let finalDropCols = columns.filter((item) => {
    if (!staticCols.includes(item.headerName)) {
      return item.headerName;
    }
  });
  // (finalDropCols);

  const gridOptions = {
    filter: "false",
    pagination: false,
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const [selected, setSelected] = useState([]);
  // (selected);

  const requestSearch = (searchedVal) => {
    setSearched(searchedVal);
    let rowsTemp = [...orignalRows];
    setPage(0);
    // (searchedVal);
    const query = searchedVal ? searchedVal : searched;
    // getData(query);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // (Boolean(currentTarget));
    // setAnchorEl(true);
    setIsMenuOpen(true);
  };

  // const [clearFilter, appliedFilter, setAppliedFilter, filterState, setFilterState, filterList, setFilterList, Filter, getFilterParams] = useFilter('prospect_manager');
  const [Filter, filterString, passFilters, passData] =
    useFilter("prospect_manager");
  // (filterString);

  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const getPaginationURL = (url, newQuery) => {
    const query = newQuery ? newQuery : searched;

    // var selectedRows=[...datas];
    // ('am datas', selectedRows);

    var retrievedObject = localStorage.getItem("testObject");
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    setParamObject(myparam);
    getData();

    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
  }, [page, rowsPerPage, filterString, totalRowCount]);

  // (myparam, "ccfgbn");

  const getData = (newQuery) => {
    toast.loading("Please wait...");
    if (myparam && myparam.cust_id) {
      let cust_id = myparam.cust_id;
      let ids = myparam.id;
      // (ids, backid, location.asset_id);
      http
        .get("/research_subchild/" + cust_id + "/" + (ids || location.asset_id))
        .then((res) => {
          toast.dismiss();
          if (res.data.statusCode === 0 && res.data.data.length !== 0) {
            let tempDta = res.data.data;
            setOriginalRows(res.data.data);
            setRows(res.data.data);
            let tempRows = [];
            let finalData = [];
            let tempStatusDta = tempDta.map((item, index) => {
              const swapValue = (item) => {
                Object.keys(item).forEach((key) => {
                  //(Object.keys(item));
                  // if (!item[key]) {
                  //     item[key] = "N/A";
                  // }
                });
              };
              swapValue(item);
              finalData.push((item.date = getDateTime(item.date)));
              return item;
            });

            setOriginalRows(tempDta);
            setRows(tempDta);
          } else {
            setOriginalRows([]);
            setRows([]);
          }
        })
        .catch((err) => {
          toast.error("");
        });
    }
  };

  const handleColChange = (event) => {
    const value = event.target.value;

    setSelected(value);
    let newCols = columns.map((item) => {
      let findSelect = value.find((list) => {
        if (list === item.headerName) {
          // return item;
          item.show = true;
          // (item);
          return item;
          // setColumns(item);
        } else {
          item.show = false;
        }
      });
      return newCols;
    });

    // let parsedVal = JSON.parse(value);
    localStorage.setItem("slectProspectCols", value);
  };

  let filteredCol = columns.filter((data) => {
    if (data.show) {
      return data;
    }
  });
  // (filteredCol);

  const saveColumns = () => {
    let finalCols = staticCols.concat(selected);
    let sendFinalCols = [...new Set(finalCols)];
    // (finalCols);
    // (sendFinalCols);

    let finalObjet = {
      emp_id: localStorage.getItem("employee_id"),
      columns: sendFinalCols,
    };

    http
      .post("/prospectempcolumns", finalObjet)
      .then((response) => {
        if (response.data.statusCode === 0) {
          toast.success(response.data.data);
          setShowMenuCol(false);
        } else {
          toast.error("Columns not saved!");
        }

        // setFromObject(form)
      })
      .catch((error) => {
        console.log("error");
      });
  };

  // (rows);
  // (orignalRows);

  const applyFilter = (e) => {
    // (e);
    // (e.target);
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  const handleMenuClose = () => {
    // ('closefunction')
    // setAnchorEl(false);
    setIsMenuOpen(false);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
  };

  const gotoProspect = () => {
    history.push({
      // pathname: prospectPath,
      pathname: viewMitsChildReportsPath,
      //pathname: viewMitsReportsPath,
      state: paramObject,
      sendid: backid,
      asset_id: location.asset_id,
      // state: { tab: "Ticket Manager" },
    });
  };
  const [menuCol, setShowMenuCol] = useState(false);

  const showMenuFilter = (e) => {
    setShowMenuCol((val) => !val);
  };

  // (columns);

  return (
    <>
      <Grid
        item
        xs={12}
        sm={5}
        md={5}
        align="left"
        className={"overviewbar"}
        style={{ marginBottom: 50, marginTop: 30 }}
      >
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoProspect}
          //onClick={() => history.push("/dashboard/addinternalsupport")}
        >
          Back
        </Button>
      </Grid>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              // className={"mt30"}
              // style={{border:'3px solid blue', width:'10rem'}}
            />
          </div>
        </div>
        <Grid container>
          <Grid item xs={10} sm={11} style={{ paddingTop: 10 }}>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 1500]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
          {/* <Grid item xs={2} sm={1}>
                        <SvgIcon
                            style={{ cursor: "pointer", marginTop: 20 }}
                            onClick={openFilter}
                            title={"filter"}
                        >
                            <FilterLogo />
                        </SvgIcon>
                         <Menu
                            anchorEl={anchorEl}
                            id={"Filtermenu"}
                            keepMounted
                            open={isMenuOpen}
                            onClose={handleMenuClose}
                            getContentAnchorEl={null}
                            transformOrigin={{ horizontal: "rigth", vertical: "top" }}
                            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >
                            <Filter
                                columns={columns}
                                applyFilter={applyFilter}
                                orignalRows={orignalRows}
                                handleChange={handleChange}
                                formObject={formObject}
                                clearFilter={clearFilter}
                            />
                        </Menu> 
                </Grid> */}
        </Grid>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.headerName}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {rows.length !== 0 ? (
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                        className="prospecttable"
                      >
                        {columns.map((column, index) => {
                          const text = row.comments;

                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : column.id === "detailsButton" ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ borderRadius: 20 }}
                                  // onClick={() => viewDetails(row)}
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/addinternalsupport"
                                    )
                                  }
                                >
                                  View Details
                                </Button>
                              ) : column.operation &&
                                column.operation === "concate" ? (
                                value + column.operand + row[column.with]
                              ) : column.type &&
                                column.type === "link" &&
                                value ? (
                                <Link
                                  variant="body2"
                                  // onClick={(e) => viewDetails(row)}

                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : column.type &&
                                column.type === "attach" &&
                                value ? (
                                <Link
                                  // href={staticFiles + value}
                                  target="_blank"
                                  variant="body2"
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : column.format === "Date" ? (
                                getDate(value)
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            ) : (
              <TableCell
                colspan="9"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                No Data Available...
              </TableCell>
            )}
          </Table>
        </TableContainer>

        <div>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    </>
  );
}
